import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AttributeValueDto, AttributeValuesDto } from '../models/AttributeValue';
import { BaseService } from './base.service';
import { OAuthServiceService } from './o-auth-service.service';

@Injectable({ providedIn: 'root' })
export class AttributeValueService extends BaseService {

  constructor(private httpClient: HttpClient,
    private oauthService: OAuthServiceService) {
    super();
  }

  getAttributeValue(id: string, dbname: string): Observable<AttributeValueDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.get<AttributeValueDto>(`${this.attributeValue}/${id}`, { headers: headers });
  }

  getDocumentAttributeValue(documentId: string, pageId: string, dbname: string): Observable<AttributeValueDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.get<AttributeValueDto>(`${this.attributeValue}/${documentId}/DocumentAttributeValue?pageId=${pageId}`, { headers: headers });
  }

  load(documentId: string, valueConfAttrId: string, dbname: string): Observable<AttributeValueDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.get<AttributeValueDto>(`${this.attributeValue}/ActiveAttributeValue?documentId=${documentId}&valueConfAttrId=${valueConfAttrId}`, { headers: headers });
  }

  loadAttributeValues(searchText: string, docStereoTypeId: string, documentId: string, page: number, pageSize: number, dbname: string): Observable<AttributeValuesDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.get<AttributeValuesDto>(`${this.attributeValue}?searchText=${searchText}&docStereoTypeId=${docStereoTypeId}&documentId=${documentId}&page=${page}&pageSize=${pageSize}`, { headers: headers });
  }

  loadCurrentAttributeValue(searchText: string, documentId: string, pageId: string, page: number, pageSize: number, dbname: string): Observable<AttributeValueDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.get<AttributeValueDto>(`${this.attributeValue}/CurrentAttributeValue?documentId=${documentId}&pageId=${pageId}&page=${page}&pageSize=${pageSize}`, { headers: headers });
  }

  loadDocumentAttributeValues(searchText: string, documentId: string, page: number, pageSize: number, dbname: string): Observable<AttributeValueDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.get<AttributeValueDto>(`${this.attributeValue}/DocumentAttributeValues?documentId=${documentId}&page=${page}&pageSize=${pageSize}`, { headers: headers });
  }

  createAttributValue(documentId: string, valueConfAttrId: string, attributeValueDto: AttributeValueDto, dbname: string): Observable<AttributeValueDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.post<AttributeValueDto>(`${this.attributeValue}?documentId=${documentId}&valueConfAttrId=${valueConfAttrId}`, attributeValueDto, { headers: headers });
  }

  createAttributValueInfo(documentId: string, pageId: string, formData: any, key: string, id: string, dbname: string): Observable<any> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.post<any>(`${this.attributeValue}/AttributeValueInfo?documentId=${documentId}&key=${key}&id=${id}&pageId=${pageId}`, formData, { headers: headers });
  }

  updateAttributeValue(attributeValueDto: AttributeValueDto, dbname: string): Observable<AttributeValueDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.put<AttributeValueDto>(`${this.attributeValue}/${attributeValueDto.id}`, attributeValueDto, { headers: headers });
  }

  deleteAttributeValue(attributeValueDto: AttributeValueDto, dbname: string): Observable<AttributeValueDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.delete<AttributeValueDto>(`${this.attributeValue}/${attributeValueDto.id}`, { headers: headers });
  }

  uploadFile(formData: FormData, dbname: string): Observable<any> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.post<any>(`${this.attributeValue}/UploadFile`, formData, { headers: headers, reportProgress: true, observe: 'events' });
  }
}
